const {normalizeRegistrySearch, registrySearchWords} = require('./employeeRegistrySearch');

function workforceEmployeeSearchText(employee, name) {
    const contacts = (Array.isArray(employee.contacts) ? employee.contacts : []).map(contact => (
        typeof contact === 'string' ? contact
            : [contact.label, contact.value, contact.contact].filter(Boolean).join(' ')
    )).join(' ');
    return normalizeRegistrySearch([
        name, employee.display_name, employee.full_name, employee.middle_name,
        employee.position, employee.operational_position, employee.citizenship,
        ...(employee.skills || []), employee.department_name, ...(employee.department_names || []), contacts
    ].filter(Boolean).join(' '));
}

function matchesWorkforceSearch(text, words) {
    return words.every(word => text.includes(word));
}

module.exports = {workforceEmployeeSearchText, matchesWorkforceSearch, registrySearchWords};
